export const getDraggedItem = state => state.formDragDrop.draggedItem;